
document.addEventListener('DOMContentLoaded', () => {
// 1. ELEMENTOS DEL DOM

// Popup de video principal
const videoPopup = document.querySelector('.video-popup');

// Elementos generales del documento
const containerMetafield = videoPopup.querySelector('.meta_content');
const caretHeader = videoPopup.querySelector('.caret-header');
const caretContent = videoPopup.querySelector('.caret-content');
const caretUp = videoPopup.querySelector('.caret-icon-up');
const caretDown = videoPopup.querySelector('.caret-icon-down');

// Contenedores de controles
const controlsBar = videoPopup.querySelector('.controls');
const controlsBarPhone = videoPopup.querySelector('.controls_phone');

// Elementos del video y contenido
const video = videoPopup.querySelector('.normal-video');
const fullVideoContent = videoPopup.querySelector('.full-video-content');
const logoEikoContainer = videoPopup.querySelector('.logo_eiko_symbol');

// Controles de cierre y modo completo
const closePopupButton = videoPopup.querySelector('.close-popup');
const fullVideoButton = videoPopup.querySelector('.full-video');
const closeFullVideo = videoPopup.querySelector('.close-full-video');

// Controles de reproducción
const playPauseButton = videoPopup.querySelector('.toggle-play-pause');
const playPauseButtonPhone = videoPopup.querySelector('.toggle-play-pause-phone');
const playIcon = playPauseButton.querySelector('.play-icon');
const pauseIcon = playPauseButton.querySelector('.pause-icon');
const playIconPhone = playPauseButtonPhone.querySelector('.play-icon-phone');
const pauseIconPhone = playPauseButtonPhone.querySelector('.pause-icon-phone');

// Barra de progreso
const progressContainer = videoPopup.querySelector('.video-progress-container');
const progressContainerPhone = videoPopup.querySelector('.video-progress-container-phone');
const progressBar = progressContainer.querySelector('.video-progress');
const progressBarPhone = progressContainerPhone.querySelector('.video-progress');

// Controles de volumen - desktop
const volumeContainer = videoPopup.querySelector('.volume-container');
const volumeSlider = videoPopup.querySelector('.volume-slider');
const muteUnmuteButton = videoPopup.querySelector('.toggle-mute-unmute');
const muteIcon = muteUnmuteButton.querySelector('.mute-icon');
const unmuteIcon = muteUnmuteButton.querySelector('.unmute-icon');
const volumeFullIcon = videoPopup.querySelector('.mute-icon-full');
const volumeMuteIcon = videoPopup.querySelector('.unmute-icon-full');

// Controles de volumen - mobile
const volumeContainerPhone = videoPopup.querySelector('.volume-container-phone');
const volumeFullIconPhone = volumeContainerPhone.querySelector('.mute-icon-full-phone');
const volumeMuteIconPhone = volumeContainerPhone.querySelector('.unmute-icon-full-phone');

// Elementos para secondary media
const secondaryMediaContainer = videoPopup.querySelector('.secondary-media-container');
const mediaToggleButtons = videoPopup.querySelectorAll('.media-toggle-option');
const storySegments = secondaryMediaContainer?.querySelectorAll('.story-segment');
const secondaryMediaItems = secondaryMediaContainer?.querySelectorAll('.secondary-video, .secondary-image');
    
  // const bgVideoBlurred = videoPopup.querySelector('.bg-video'); 

  // 2. VARIABLES DE ESTADO
  let isDragging = false;
  let offsetX = 0, offsetY = 0;
  let lastX = 0, lastY = 0;
  let velocityX = 0, velocityY = 0;
  let animationFrameId = null;
  let isHover = false;
  let translateX, translateY;
  let hideTimeout, controlsTimeout;
  let dragStartTime = 0;
  let lastTimestamp = 0;
  let savedTranslateX = 0;
  let savedTranslateY = 0;
  let caretExpanded = false;
  let isFullScreenMode = false;
  let showingSecondaryMedia = false;
  let currentMediaIndex = 0;
  let storyInterval = null;
  let storyProgressInterval = null;
  const STORY_DURATION = 3000;

  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  // Función para expandir/contraer el contenido
  const toggleCaretContent = (expanded) => {
    if (expanded) {
      caretContent.classList.add('expanded');
      caretUp.style.display = 'none';
      caretDown.style.display = 'inline';
    } else {
      caretContent.classList.remove('expanded');
      caretUp.style.display = 'inline';
      caretDown.style.display = 'none';
    }
  };

  // Click en caret-header
  caretHeader?.addEventListener('click', () => {
    const isExpanded = caretContent.classList.contains('expanded');
    toggleCaretContent(!isExpanded);
  });

  // Drag vertical para product_info_modal (solo móvil)
  if (isMobile) {
    const productInfoModal = videoPopup.querySelector('.product_info_modal');
    let dragStartY = 0;
    let dragCurrentY = 0;
    let isDraggingModal = false;
    let startTime = 0;
    let wasExpanded = false;

    // DRAG DEL PRODUCT INFO MODAL (solo dentro del modal)
    productInfoModal?.addEventListener('touchstart', (e) => {
      if (showingSecondaryMedia) return;
      if (!videoPopup.classList.contains('full-screen')) return;
      
      dragStartY = e.touches[0].clientY;
      dragCurrentY = dragStartY;
      isDraggingModal = false;
      startTime = Date.now();
      wasExpanded = caretContent.classList.contains('expanded');

      caretContent.style.transition = 'none';
      
      e.stopPropagation();
    }, { passive: true });

    productInfoModal?.addEventListener('touchmove', (e) => {
      if (showingSecondaryMedia) return;
      if (!videoPopup.classList.contains('full-screen')) return;
      
      dragCurrentY = e.touches[0].clientY;
      const deltaY = dragCurrentY - dragStartY;
      
      if (Math.abs(deltaY) > 10) {
        isDraggingModal = true;
        const maxHeight = caretContent.scrollHeight;
        
        if (wasExpanded) {
          // Si estaba expandido, contraer según drag hacia abajo
          if (deltaY > 0) {
            const progress = Math.min(deltaY / 150, 1); // 150px para colapsar completamente
            const currentHeight = maxHeight * (1 - progress);
            caretContent.style.maxHeight = `${currentHeight}px`;
            caretContent.style.opacity = `${1 - progress * 0.3}`;
          }
        } else {
          // Si estaba contraído, expandir según drag hacia arriba
          if (deltaY < 0) {
            const progress = Math.min(Math.abs(deltaY) / 150, 1); // 150px para expandir completamente
            const currentHeight = maxHeight * progress;
            caretContent.style.maxHeight = `${currentHeight}px`;
            caretContent.style.opacity = `${0.7 + progress * 0.3}`;
          }
        }
      }
      
      e.stopPropagation();
    }, { passive: true });

    productInfoModal?.addEventListener('touchend', (e) => {
      if (showingSecondaryMedia) return;
      if (!videoPopup.classList.contains('full-screen') || !isDraggingModal) return;
      
      const deltaY = dragCurrentY - dragStartY;
      const deltaTime = Date.now() - startTime;
      const velocity = Math.abs(deltaY) / deltaTime;

      caretContent.style.transition = '';
      caretContent.style.maxHeight = '';
      caretContent.style.opacity = '';
      
      const threshold = 50;
      
      if (deltaY < -threshold || (velocity > 0.5 && deltaY < 0)) {
        toggleCaretContent(true);
      } else if (deltaY > threshold || (velocity > 0.5 && deltaY > 0)) {
        toggleCaretContent(false);
      } else {
        toggleCaretContent(wasExpanded);
      }
      
      isDraggingModal = false;
      e.stopPropagation(); // DETENER PROPAGACIÓN
    });

    // DRAG DEL VIDEO POPUP (cerrar full-screen)
    let touchStartY = 0;
    let touchCurrentY = 0;
    let isSwiping = false;
    let initialTranslateY = 0;
  
    videoPopup.addEventListener('touchstart', (e) => {
      if (!videoPopup.classList.contains('full-screen')) return;
      
      // SI EL TOUCH ES DENTRO DEL MODAL, NO HACER NADA
      if (productInfoModal && productInfoModal.contains(e.target)) return;
    
      const backdrop = document.getElementById('popup-backdrop');
      backdrop?.classList.add('active');
    
      initialTranslateY = 0;
    
      touchStartY = e.touches[0].clientY;
      touchCurrentY = touchStartY;
      isSwiping = true;
      videoPopup.style.transition = 'none';
    });

    videoPopup.addEventListener('touchmove', (e) => {
      if (!isSwiping || !videoPopup.classList.contains('full-screen')) return;
      
      // SI EL TOUCH ES DENTRO DEL MODAL, NO HACER NADA
      if (productInfoModal && productInfoModal.contains(e.target)) return;
    
      touchCurrentY = e.touches[0].clientY;
      const deltaY = touchCurrentY - touchStartY;
    
      if (deltaY > 0) {
        const progress = Math.min(deltaY / window.innerHeight, 1);
        const scaleFactor = 1 - progress * 0.1;
    
        videoPopup.style.transform = `translateY(${initialTranslateY + deltaY}px) scale(${scaleFactor})`;
        videoPopup.style.borderRadius = `${8 * (1 + progress * 2)}px`;
        videoPopup.style.boxShadow = '0 0 0 1px rgba(255,255,255,0.1)';
        video.style.borderRadius = `${8 * (1 + progress * 2)}px`;
    
        e.preventDefault();
      }
    }, { passive: false });

    videoPopup.addEventListener('touchend', (e) => {
      if (!isSwiping || !videoPopup.classList.contains('full-screen')) return;
    
      const backdrop = document.getElementById('popup-backdrop');
      backdrop?.classList.remove('active');
    
      isSwiping = false;
      const deltaY = touchCurrentY - touchStartY;
      const threshold = window.innerHeight * 0.3;
    
      videoPopup.style.boxShadow = '';
      video.style.borderRadius = '';
      videoPopup.style.borderRadius = '';
    
      if (deltaY > threshold) {
        videoPopup.style.transition = 'transform 300ms ease-out, opacity 300ms ease-out';
        videoPopup.style.transform = 'translate(100vw, 100vh) scale(0.5)';
        videoPopup.style.opacity = '0';
    
        const onTransitionEnd = (e) => {
          if (e.propertyName !== 'opacity') return;
          videoPopup.removeEventListener('transitionend', onTransitionEnd);
          if (showingSecondaryMedia) {
            secondaryMediaContainer.style.display = 'none';
            stopStoryCarousel();
            showingSecondaryMedia = false;
            
            mediaToggleButtons.forEach(btn => {
              if (btn.dataset.media === 'main') {
                btn.classList.add('active');
              } else {
                btn.classList.remove('active');
              }
            });
          }

          video.style.display = 'block';
          if (caretHeader) caretHeader.style.display = 'flex';
    
          video.muted = true;
          muteIcon.style.display = 'inline-block';
          unmuteIcon.style.display = 'none';
          videoPopup.classList.remove('full-screen');
          document.body.style.overflow = '';
          translateX = savedTranslateX;
          translateY = savedTranslateY;
          applyTransform();
    
          progressContainer.style.display = 'none';
          closeFullVideo.style.display = 'none';
          playPauseButton.style.display = 'none';
          volumeContainer.style.display = 'none';
          logoEikoContainer.style.display = 'none';
    
          video.style.width = '';
          video.style.height = '';
    
          videoPopup.style.transition = '';
          videoPopup.style.transform = '';
          videoPopup.style.opacity = '';
          videoPopup.style.borderRadius = '';
        };
    
        videoPopup.addEventListener('transitionend', onTransitionEnd);
      } else {
        videoPopup.style.transition = 'transform 200ms ease-out';
        videoPopup.style.transform = `translateY(0px) scale(1)`;
    
        logoEikoContainer.style.display = 'block';
    
        setTimeout(() => {
          videoPopup.style.transition = '';
        }, 200);
      }
    });
  }

  const transform = getComputedStyle(videoPopup).transform;
  if (transform && transform !== 'none') {
    const match = transform.match(/matrix\(([^)]+)\)/);
    if (match) {
      const values = match[1].split(',').map(parseFloat);
      translateX = values[4];
      translateY = values[5];
    }
  }

  // 3. FUNCIONES AUXILIARES
  
  const preloadSecondaryMedia = () => {
    if (!secondaryMediaItems) return;

    secondaryMediaItems.forEach(item => {
      const dataSrc = item.getAttribute('data-src');
      if (!dataSrc) return;

      if (!item.src && item.tagName !== 'VIDEO') item.src = dataSrc;

      if (item.tagName === 'VIDEO' && item.children.length === 0) {
        const source = document.createElement('source');
        source.src = dataSrc;
        source.type = 'video/mp4';
        item.appendChild(source);
        item.load();
      }
    });
  };


  const applyTransform = (x = translateX, y = translateY) => {
    if (videoPopup.classList.contains('full-screen')) return;
    translateX = x;
    translateY = y;
    let transformValue = `translateX(${x}px) translateY(${y}px)`;
    transformValue += isHover ? ' scale(1.05)' : ' scale(1)';
    videoPopup.style.transform = transformValue;
  };

  const toggleMuteUnmute = () => {
    video.muted = !video.muted;
    video.volume = video.muted ? 0 : 1;
  };

  const updateMuteUnmuteIcons = (muteEl, unmuteEl) => {
    const isMuted = video.muted;
    muteEl.style.display = isMuted ? 'inline-block' : 'none';
    unmuteEl.style.display = isMuted ? 'none' : 'inline-block';
  };
  const toggleVolumeSlider = (visible) => {
    volumeSlider.style.display = visible ? 'block' : 'none';
  };

  const handleVolumeSliderVisibility = (el, entering) => {
    if (entering) {
      toggleVolumeSlider(true);
      clearTimeout(hideTimeout);
    } else {
      hideTimeout = setTimeout(() => toggleVolumeSlider(false), 300);
    }
  };

  const getClientPosition = (e) => ({
    x: e.clientX || e.touches[0].clientX,
    y: e.clientY || e.touches[0].clientY,
  });

  const togglePlayPause = (playIconElement, pauseIconElement) => {
    if (video.paused) {
      video.play();
      playIconElement.style.display = 'none';
      pauseIconElement.style.display = 'inline-block';
    } else {
      video.pause();
      playIconElement.style.display = 'inline-block';
      pauseIconElement.style.display = 'none';
    }
  };

  const toggleMedia = (button) => {
      const mediaType = button.dataset.media;

      // Si vamos a secondary media y aún no está mostrando
      if (mediaType === 'secondary' && !showingSecondaryMedia) {
          // Pausar video principal
          video.pause();
          video.style.display = 'none';

          // Mostrar contenedor secondary
          secondaryMediaContainer.style.display = 'block';

          // Preload de videos e imágenes
          secondaryMediaItems.forEach(item => {
              const dataSrc = item.getAttribute('data-src');
              if (!dataSrc) return;

              if (!item.src && item.tagName !== 'VIDEO') item.src = dataSrc;

              if (item.tagName === 'VIDEO' && item.children.length === 0) {
                  const source = document.createElement('source');
                  source.src = dataSrc;
                  source.type = 'video/mp4';
                  item.appendChild(source);
                  item.load();
              }
          });

          // Esperar al próximo frame para iniciar carousel (evita blink)
          requestAnimationFrame(() => {
              startStoryCarousel();
          });

          if (caretHeader) caretHeader.style.display = 'none';
          if (caretContent) caretContent.classList.remove('expanded');

          showingSecondaryMedia = true;

          mediaToggleButtons.forEach(btn => btn.classList.remove('active'));
          button.classList.add('active');

      } 
      // Si vamos a main media y actualmente estamos en secondary
      else if (mediaType === 'main' && showingSecondaryMedia) {
          stopStoryCarousel();
          secondaryMediaContainer.style.display = 'none';

          // Restaurar video principal
          video.style.display = 'block';
          video.play();

          if (caretHeader) caretHeader.style.display = 'flex';

          showingSecondaryMedia = false;

          mediaToggleButtons.forEach(btn => btn.classList.remove('active'));
          button.classList.add('active');
      }
  };


  const showMediaAtIndex = (index) => {
    // Ocultar todos los medias
    secondaryMediaItems.forEach(item => {
        item.style.display = 'none';
        if (item.tagName === 'VIDEO') item.pause();
    });
    
    // Mostrar el media en el índice especificado
    if (secondaryMediaItems[index]) {
        secondaryMediaItems[index].style.display = 'block';
        if (secondaryMediaItems[index].tagName === 'VIDEO') {
        secondaryMediaItems[index].play();
        }
    }
    
    currentMediaIndex = index;
    };

    const resetStoryProgress = () => {
        storySegments.forEach(segment => {
            const fill = segment.querySelector('.story-segment-fill');
            fill.style.transition = 'none';
            fill.style.width = '0%';
        });
    };
    const getDurationForMedia = (index) => {
      const mediaItem = secondaryMediaItems[index];
      if (!mediaItem) return STORY_DURATION;
      
      if (mediaItem.tagName === 'VIDEO') {
          if (mediaItem.readyState >= 1 && mediaItem.duration) {
              return mediaItem.duration * 1000;
          }
          return STORY_DURATION; // fallback mientras carga
      }
      return STORY_DURATION; // imágenes usan duración default
  };

    const fillStorySegment = (index) => {
    // Mantener todas las barras anteriores al 100%
    storySegments.forEach((segment, i) => {
        const fill = segment.querySelector('.story-segment-fill');
        if (i < index) {
            fill.style.transition = 'none';
            fill.style.width = '100%';
        } else if (i > index) {
            fill.style.transition = 'none';
            fill.style.width = '0%';
        }
    });
    
    // Animar solo la barra activa
    const activeFill = storySegments[index].querySelector('.story-segment-fill');
    void activeFill.offsetWidth; // Forzar reflow
    
    requestAnimationFrame(() => {
        activeFill.style.transition = `width ${getDurationForMedia(index)}ms linear`;
        activeFill.style.width = '100%';
    });
};

const nextMedia = () => {
    const nextIndex = (currentMediaIndex + 1) % secondaryMediaItems.length;
    
    // Si volvemos al inicio, hacer reset completo
    if (nextIndex === 0) {
        resetStoryProgress();
    }
    
    showMediaAtIndex(nextIndex);
    fillStorySegment(nextIndex);

    clearTimeout(storyInterval);
    
    const nextItem = secondaryMediaItems[nextIndex];
    
    if (nextItem.tagName === 'VIDEO') {
        if (nextItem.readyState >= 1 && nextItem.duration) {
            const duration = nextItem.duration * 1000;
            storyInterval = setTimeout(nextMedia, duration);
        } else {
            // Esperar a que el video cargue sus metadatos
            nextItem.addEventListener('loadedmetadata', () => {
                const duration = nextItem.duration * 1000;
                clearTimeout(storyInterval);
                storyInterval = setTimeout(nextMedia, duration);
            }, { once: true });
            // Usar duración default mientras tanto
            storyInterval = setTimeout(nextMedia, STORY_DURATION);
        }
    } else {
        storyInterval = setTimeout(nextMedia, STORY_DURATION);
    }
};
const startStoryCarousel = () => {
    resetStoryProgress();
    showMediaAtIndex(0);
    fillStorySegment(0);
    clearTimeout(storyInterval);
    
    const firstItem = secondaryMediaItems[0];
    
    if (firstItem.tagName === 'VIDEO') {
        if (firstItem.readyState >= 1 && firstItem.duration) {
            const duration = firstItem.duration * 1000;
            storyInterval = setTimeout(nextMedia, duration);
        } else {
            firstItem.addEventListener('loadedmetadata', () => {
                const duration = firstItem.duration * 1000;
                clearTimeout(storyInterval);
                storyInterval = setTimeout(nextMedia, duration);
            }, { once: true });
            storyInterval = setTimeout(nextMedia, STORY_DURATION);
        }
    } else {
        storyInterval = setTimeout(nextMedia, STORY_DURATION);
    }
};

const goToMedia = (index) => {
    clearTimeout(storyInterval);
    
    const isGoingBackward = index < currentMediaIndex || (currentMediaIndex === 0 && index === secondaryMediaItems.length - 1);
    
    // Asegurar que el índice esté dentro del rango
    if (index < 0) index = secondaryMediaItems.length - 1;
    if (index >= secondaryMediaItems.length) index = 0;
    
    // Si vamos hacia atrás, resetear la barra del slide al que vamos
    if (isGoingBackward) {
        const targetFill = storySegments[index].querySelector('.story-segment-fill');
        targetFill.style.transition = 'none';
        targetFill.style.width = '0%';
    }
    
    // Si volvemos al inicio yendo hacia adelante, hacer reset completo
    if (index === 0 && !isGoingBackward) {
        resetStoryProgress();
    }
    
    showMediaAtIndex(index);
    fillStorySegment(index);
    
    const currentItem = secondaryMediaItems[index];
    
    if (currentItem.tagName === 'VIDEO') {
        if (currentItem.readyState >= 1 && currentItem.duration) {
            const duration = currentItem.duration * 1000;
            storyInterval = setTimeout(nextMedia, duration);
        } else {
            currentItem.addEventListener('loadedmetadata', () => {
                const duration = currentItem.duration * 1000;
                clearTimeout(storyInterval);
                storyInterval = setTimeout(nextMedia, duration);
            }, { once: true });
            storyInterval = setTimeout(nextMedia, STORY_DURATION);
        }
    } else {
        storyInterval = setTimeout(nextMedia, STORY_DURATION);
    }
};

    const stopStoryCarousel = () => {
    clearInterval(storyInterval);
    clearInterval(storyProgressInterval);
    resetStoryProgress();
    currentMediaIndex = 0;
    };

  const inertia = () => {
    const friction = 0.95;
    const threshold = 0.02;
  
    velocityX *= friction;
    velocityY *= friction;
    translateX += velocityX * 16;
    translateY += velocityY * 16;
  
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    const pw = videoPopup.offsetWidth;
    const ph = videoPopup.offsetHeight;
  
    let rebounded = false;
  
    // Limitar salida parcial (margin fuera permitido)
    const margin = 80;
  
    // Eje X
    if (translateX < -margin) {
      translateX = -margin;
      velocityX = 0;
      rebounded = true;
    } else if (translateX > vw - pw + margin) {
      translateX = vw - pw + margin;
      velocityX = 0;
      rebounded = true;
    }
  
    // Eje Y
    if (translateY < -margin) {
      translateY = -margin;
      velocityY = 0;
      rebounded = true;
    } else if (translateY > vh - ph + margin) {
      translateY = vh - ph + margin;
      velocityY = 0;
      rebounded = true;
    }
  
    // Aplicar movimiento
    applyTransform(translateX, translateY);
  
    // Seguir animando solo si hay velocidad real y no se ha frenado por rebote
    const speed = Math.sqrt(velocityX ** 2 + velocityY ** 2);
    if (speed > threshold && !rebounded) {
      animationFrameId = requestAnimationFrame(inertia);
    } else {
      cancelAnimationFrame(animationFrameId);
      // Llamar a bounceBack suave, si está parcialmente fuera
      if (translateX < 0 || translateY < 0 || translateX > vw - pw || translateY > vh - ph) {
        bounceBack();
      }
    }
  };

  const bounceBack = () => {
    if (videoPopup.classList.contains('full-screen')) return;
    cancelAnimationFrame(animationFrameId);
    const vw = window.innerWidth, vh = window.innerHeight;
    const pw = videoPopup.offsetWidth, ph = videoPopup.offsetHeight;
    const tx = Math.max(0, Math.min(translateX, vw - pw));
    const ty = Math.max(0, Math.min(translateY, vh - ph));
    const dx = tx - translateX, dy = ty - translateY;
    if (dx !== 0 || dy !== 0) {
      let startTime = null;
      const duration = 600;
      const easeOutBack = (t) => {
        const c1 = 1.70158, c3 = c1 + 1;
        return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
      };
      const animate = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const ease = easeOutBack(progress);
        translateX = tx - dx * (1 - ease);
        translateY = ty - dy * (1 - ease);
        videoPopup.style.transform = `translateX(${translateX}px) translateY(${translateY}px) scale(${0.9 + 0.1 * ease})`;
        if (progress < 1) {
          animationFrameId = requestAnimationFrame(animate);
        } else {
          isHover = videoPopup.matches(':hover');
          applyTransform();
        }
      };
      videoPopup.style.transition = 'none';
      animationFrameId = requestAnimationFrame(animate);
    }
  };

  const startDrag = (e) => {
    if (videoPopup.classList.contains('full-screen')) return;
    isDragging = true;
    document.body.style.overflow = 'hidden';
    const { x, y } = getClientPosition(e);
    offsetX = x - translateX;
    offsetY = y - translateY;
    lastX = x;
    lastY = y;
    dragStartTime = Date.now();
    lastTimestamp = dragStartTime;
    videoPopup.style.transition = 'none';
    videoPopup.classList.add('dragging');
  };

  const drag = (e) => {
    if (!isDragging || videoPopup.classList.contains('full-screen')) return;
    const { x, y } = getClientPosition(e);
    const now = Date.now();
    const deltaTime = now - lastTimestamp || 16; // fallback a 60fps
    velocityX = (x - lastX) / deltaTime;
    velocityY = (y - lastY) / deltaTime;
    translateX = x - offsetX;
    translateY = y - offsetY;
    applyTransform(translateX, translateY);
    lastX = x;
    lastY = y;
    lastTimestamp = now;
  };

  const endDrag = () => {
    if (!isDragging || videoPopup.classList.contains('full-screen')) return;
    isDragging = false;
    videoPopup.classList.remove('dragging');
    document.body.style.overflow = '';
    cancelAnimationFrame(animationFrameId);
    animationFrameId = requestAnimationFrame(inertia);
  };

  if (isMobile) {
    let touchStartY = 0;
    let touchCurrentY = 0;
    let isSwiping = false;
    let initialTranslateY = 0;
  
    videoPopup.addEventListener('touchstart', (e) => {
      if (!videoPopup.classList.contains('full-screen')) return;
    
      const backdrop = document.getElementById('popup-backdrop');
      backdrop?.classList.add('active');
    
      initialTranslateY = 0; 
    
      touchStartY = e.touches[0].clientY;
      touchCurrentY = touchStartY;
      isSwiping = true;
      videoPopup.style.transition = 'none';
    });
    videoPopup.addEventListener('touchmove', (e) => {
      if (!isSwiping || !videoPopup.classList.contains('full-screen')) return;
    
      touchCurrentY = e.touches[0].clientY;
      const deltaY = touchCurrentY - touchStartY;
    
      if (deltaY > 0) {
        const progress = Math.min(deltaY / window.innerHeight, 1);
        const scaleFactor = 1 - progress * 0.1;
    
        videoPopup.style.transform = `translateY(${initialTranslateY + deltaY}px) scale(${scaleFactor})`;
        videoPopup.style.borderRadius = '8px';
        videoPopup.style.boxShadow = '0 0 0 1px rgba(255,255,255,0.1)';
        video.style.borderRadius = '8px';
    
        e.preventDefault();
      }
    }, { passive: false });
    videoPopup.addEventListener('touchend', () => {
      if (!isSwiping || !videoPopup.classList.contains('full-screen')) return;
    
      const backdrop = document.getElementById('popup-backdrop');
      backdrop?.classList.remove('active');
    
      isSwiping = false;
      const deltaY = touchCurrentY - touchStartY;
      const threshold = window.innerHeight * 0.3;
    
      // Limpiar estilo temporal antes de animar
      videoPopup.style.boxShadow = '';
      video.style.borderRadius = '';
      videoPopup.style.borderRadius = '';
    
      if (deltaY > threshold) {
        videoPopup.style.transition = 'transform 300ms ease-out, opacity 300ms ease-out';
        videoPopup.style.transform = 'translate(100vw, 100vh) scale(0.5)';
        videoPopup.style.opacity = '0';
    
        const onTransitionEnd = (e) => {
          if (e.propertyName !== 'opacity') return;
          videoPopup.removeEventListener('transitionend', onTransitionEnd);
    
          video.muted = true;
          muteIcon.style.display = 'inline-block';
          unmuteIcon.style.display = 'none';
          videoPopup.classList.remove('full-screen');
          document.body.style.overflow = '';
          translateX = savedTranslateX;
          translateY = savedTranslateY;
          applyTransform();
    
          progressContainer.style.display = 'none';
          closeFullVideo.style.display = 'none';
          playPauseButton.style.display = 'none';
          volumeContainer.style.display = 'none';
          logoEikoContainer.style.display = 'none';
    
          video.style.width = '';
          video.style.height = '';
    
          videoPopup.style.transition = '';
          videoPopup.style.transform = '';
          videoPopup.style.opacity = '';
          videoPopup.style.borderRadius = '';
        };
    
        videoPopup.addEventListener('transitionend', onTransitionEnd);
      } else {
        videoPopup.style.transition = 'transform 200ms ease-out';
        videoPopup.style.transform = isMobile
          ? `translateX(0px) translateY(0) scale(1)`
          : `translateX(0px) translateY(-32px) scale(1)`;
    
        // Restaurar logo si no se cierra
        logoEikoContainer.style.display = 'block';
    
        setTimeout(() => {
          videoPopup.style.transition = '';
        }, 200);
      }
    });
  }

  // 4. FUNCIONALIDAD DE TIMESTAMPS
  function enhanceMetafieldTimestampsFromElement(container) {
    if (!container) return;
    const listItems = container.querySelectorAll('li');
    const timestamps = [];

    listItems.forEach((li) => {
      const originalText = li.textContent.trim();
      if (li.querySelector('a')) return;
      const match = originalText.match(/^(\d+):(\d+)/);
      if (!match) return;

      const minutes = parseInt(match[1], 10);
      const seconds = parseInt(match[2], 10);
      const totalSeconds = minutes * 60 + seconds;

      const a = document.createElement('a');
      a.href = '#';
      a.className = 'timestamp-link';
      a.textContent = originalText;

      li.innerHTML = '';
      li.appendChild(a);
      timestamps.push(totalSeconds);

      a.addEventListener('click', (e) => {
        e.preventDefault();
        video.currentTime = totalSeconds;
        video.play();
      });
    });

    let currentActiveIndex = -1;
    const updateActiveTimestamp = () => {
      const currentTime = video.currentTime;
      for (let i = 0; i < timestamps.length; i++) {
        if (currentTime >= timestamps[i] && (i === timestamps.length - 1 || currentTime < timestamps[i + 1])) {
          if (i !== currentActiveIndex) {
            if (currentActiveIndex >= 0) {
              listItems[currentActiveIndex].classList.remove('active');
            }
            listItems[i].classList.add('active');
            currentActiveIndex = i;
          }
          break;
        }
      }
    };

    video.addEventListener('timeupdate', updateActiveTimestamp);

    if (timestamps.length > 0) {
      listItems[0].classList.add('active');
      currentActiveIndex = 0;
    }
  }

  function enhanceMetafieldTimestampsOnClickableList(container) {
    if (!container) return;
    const listItems = container.querySelectorAll('li');
    const timestamps = [];
  
    listItems.forEach((li) => {
      const originalText = li.textContent.trim();
      if (li.querySelector('.timestamp-content')) return;
  
      const [timestampPart, descriptionPart] = originalText.split(' - ');
      if (!timestampPart || !descriptionPart) return;
  
      const match = timestampPart.match(/^(\d+):(\d+)$/);
      if (!match) return;
  
      const minutes = parseInt(match[1], 10);
      const seconds = parseInt(match[2], 10);
      const totalSeconds = minutes * 60 + seconds;
  
      const span = document.createElement('span');
      span.className = 'timestamp-content';
      span.innerHTML = `${match[1]}:${match[2]}<br>${descriptionPart.trim()}`;
  
      li.innerHTML = '';
      li.appendChild(span);
      timestamps.push(totalSeconds);
  
      li.style.cursor = 'pointer';
      li.addEventListener('click', (e) => {
        e.preventDefault();
        video.currentTime = totalSeconds;
        video.play();
      });
    });
  
    let currentActiveIndex = -1;
    const updateActiveTimestamp = () => {
      const currentTime = video.currentTime;
      for (let i = 0; i < timestamps.length; i++) {
        if (
          currentTime >= timestamps[i] &&
          (i === timestamps.length - 1 || currentTime < timestamps[i + 1])
        ) {
          if (i !== currentActiveIndex) {
            if (currentActiveIndex >= 0) {
              listItems[currentActiveIndex].classList.remove('active');
            }
            listItems[i].classList.add('active');
            currentActiveIndex = i;
          }
          break;
        }
      }
    };
  
    video.addEventListener('timeupdate', updateActiveTimestamp);
  
    if (timestamps.length > 0) {
      listItems[0].classList.add('active');
      currentActiveIndex = 0;
    }
  }

  enhanceMetafieldTimestampsFromElement(containerMetafield);
  enhanceMetafieldTimestampsOnClickableList(caretContent);

  const initializeVideoTracking = () => {
    const variantId = "{{ product.selected_or_first_available_variant.id }}";
    const productName = "{{ product.title | escape }}";
    
    let maxPercentViewed = 0;
    let tracked = false;

    const updateVideoTracking = (percent) => {
      if (percent > maxPercentViewed) {
        maxPercentViewed = percent;
        
        const trackingData = {
          productName: productName,
          percentViewed: Math.round(percent),
          variantId: variantId
        };
        
        sessionStorage.setItem(`video_viewed_${variantId}`, JSON.stringify(trackingData));
        console.log('📹 Video tracking (session):', `${productName} (${Math.round(percent)}%)`);
      }
    };

    const handler = () => {
      if (!video.duration) return;
      const percent = (video.currentTime / video.duration) * 100;
      
      if (percent >= 8 && !tracked) {
        tracked = true;
        console.log('✅ Video alcanzó 8% - tracking iniciado');
      }
      
      if (tracked) {
        updateVideoTracking(percent);
      }
    };

    video.addEventListener('timeupdate', handler);
  };
  
  // 5. EVENTOS
  video.addEventListener('timeupdate', () => {
    if (!isDragging) {
      const progress = (video.currentTime / video.duration) * 100;
  
      const currentProgressBar = isMobile ? progressBarPhone : progressBar;
      currentProgressBar.value = progress;
  
      currentProgressBar.style.background = `linear-gradient(to right, #ffffff ${progress}%, #111111 ${progress}%)`;
    }
  });
  
  const handleProgressInput = (e) => {
    const seekTime = (e.target.value / 100) * video.duration;
    video.currentTime = seekTime;
  };
  
  // Registrar ambos listeners (mobile y desktop)
  progressBar.addEventListener('input', handleProgressInput);
  progressBarPhone.addEventListener('input', handleProgressInput);

  mediaToggleButtons.forEach(button => {
    button.addEventListener('click', () => toggleMedia(button));
  });

  // storySegments?.forEach(segment => {
  //   segment.addEventListener('click', () => {
  //       const index = parseInt(segment.dataset.index);
  //       clearInterval(storyInterval);
  //       clearInterval(storyProgressInterval);
  //       showMediaAtIndex(index);
  //       fillStorySegment(index);
  //       storyInterval = setInterval(nextMedia, STORY_DURATION);
  //   });
  // });

  muteUnmuteButton.addEventListener('click', () => {
    toggleMuteUnmute();
    updateMuteUnmuteIcons(muteIcon, unmuteIcon);
  });

  playPauseButton.addEventListener('click', () => {
    togglePlayPause(pauseIcon, playIcon);
  });
  playPauseButtonPhone.addEventListener('click', () => {
    togglePlayPause(pauseIconPhone, playIconPhone);
  });

  volumeSlider.addEventListener('input', (e) => {
    video.volume = parseFloat(e.target.value);
  });

  volumeContainer.addEventListener('click', () => {
    toggleMuteUnmute();
    volumeSlider.value = video.muted ? 0 : 1;
    updateMuteUnmuteIcons(volumeFullIcon, volumeMuteIcon);
  });
  volumeContainerPhone.addEventListener('click', () => {
    toggleMuteUnmute();
    volumeSlider.value = video.muted ? 0 : 1;
    updateMuteUnmuteIcons(volumeFullIconPhone, volumeMuteIconPhone);
  });

  volumeContainer.addEventListener('mouseenter', () => handleVolumeSliderVisibility(volumeContainer, true));
  volumeContainer.addEventListener('mouseleave', () => handleVolumeSliderVisibility(volumeContainer, false));
  volumeSlider.addEventListener('mouseenter', () => handleVolumeSliderVisibility(volumeSlider, true));
  volumeSlider.addEventListener('mouseleave', () => handleVolumeSliderVisibility(volumeSlider, false));

  closePopupButton.addEventListener('click', () => {
    video.pause();
    videoPopup.style.display = 'none';
  });

  closeFullVideo.addEventListener('click', () => {
    isFullScreenMode = false;
    
    // RESETEAR SECONDARY MEDIA SI ESTÁ ACTIVA
    if (showingSecondaryMedia) {
      secondaryMediaContainer.style.display = 'none';
      stopStoryCarousel();
      showingSecondaryMedia = false;
      
      // Reactivar el botón de main media
      mediaToggleButtons.forEach(btn => {
        if (btn.dataset.media === 'main') {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
    }
    
    // RESTAURAR VIDEO PRINCIPAL
    video.style.display = 'block';
    video.muted = true;
    muteIcon.style.display = 'inline-block';
    unmuteIcon.style.display = 'none';
    
    // Restaurar caret header
    if (caretHeader) caretHeader.style.display = 'flex';
    
    videoPopup.classList.remove('full-screen');
    document.body.style.overflow = '';

    translateX = savedTranslateX;
    translateY = savedTranslateY;
    applyTransform();

    progressContainer.style.display = 'none';
    closeFullVideo.style.display = 'none';
    playPauseButton.style.display = 'none';
    volumeContainer.style.display = 'none';
    logoEikoContainer.style.display = 'none';
    video.style.width = '';
    video.style.height = '';
  });

  fullVideoButton.addEventListener('click', () => {
    isFullScreenMode = true;
    savedTranslateX = translateX;
    savedTranslateY = translateY;
    translateX = 0;
    translateY = isMobile ? 0 : -32;

    video.muted = false;
    if (video.volume === 0) video.volume = 1;
    video.play();
    videoPopup.classList.add('full-screen');
    document.body.style.overflow = 'hidden';
    videoPopup.style.transition = 'none';
    videoPopup.style.transform = `translateX(${translateX}px) translateY(${translateY}px) scale(1)`;
    progressContainer.style.display = 'block';
    fullVideoButton.style.display = 'none';
    closeFullVideo.style.display = 'inline-block';
    closePopupButton.style.display = 'none';
    fullVideoContent.style.display = 'flex';
    playPauseButton.style.display = 'block';
    volumeContainer.style.display = 'block';
    muteUnmuteButton.style.display = 'none';
    logoEikoContainer.style.display = 'block';

    initializeVideoTracking();

  });

  videoPopup.addEventListener('mouseenter', () => {
    if (!videoPopup.classList.contains('full-screen')) {
      isHover = true;
      applyTransform();
    }
  });

  videoPopup.addEventListener('mouseleave', () => {
    if (!videoPopup.classList.contains('full-screen')) {
      isHover = false;
      applyTransform();
    }
  });
  
  videoPopup.addEventListener('click', (e) => {
    const videoClicked = e.target === video || video.contains(e.target);
    preloadSecondaryMedia();
    
    if (videoClicked) {
      // SOLO en móviles Y SOLO antes de full-screen: click = abrir full-screen
      if (isMobile && !videoPopup.classList.contains('full-screen')) {
        // Ejecutar la misma funcionalidad que el botón full-screen
        isFullScreenMode = true;

        // Guarda la posición actual
        savedTranslateX = translateX;
        savedTranslateY = translateY;
        translateX = 0;
        translateY = 0;
      
        video.muted = false;
        if (video.volume === 0) video.volume = 1;
        video.play();
        videoPopup.classList.add('full-screen');
        document.body.style.overflow = 'hidden';
        videoPopup.style.transition = 'none';
        videoPopup.style.transform = `translateX(${translateX}px) translateY(${translateY}px) scale(1)`;
        progressContainer.style.display = 'block';
        fullVideoButton.style.display = 'none';
        closeFullVideo.style.display = 'inline-block';
        closePopupButton.style.display = 'none';
        fullVideoContent.style.display = 'flex';
        playPauseButton.style.display = 'block';
        volumeContainer.style.display = 'block';
        muteUnmuteButton.style.display = 'none';
        logoEikoContainer.style.display = 'block';
        
        initializeVideoTracking();

        return; // Salir temprano para no ejecutar play/pause
      }
      
      // En TODOS los demás casos (desktop siempre, móvil ya en full-screen): click = play/pause (comportamiento original)
      const currentPlayIcon = isMobile ? playIconPhone : playIcon;
      const currentPauseIcon = isMobile ? pauseIconPhone : pauseIcon;
    
      togglePlayPause(currentPauseIcon, currentPlayIcon);
    
      if (videoPopup.classList.contains('full-screen')) {
        const currentControlsBar = isMobile ? controlsBarPhone : controlsBar;
    
        currentControlsBar.style.display = 'block';
        clearTimeout(controlsTimeout);
        controlsTimeout = setTimeout(() => {
          currentControlsBar.style.display = 'none';
        }, 2000);
      }
    }
  });

  secondaryMediaContainer?.addEventListener('click', (e) => {
    const containerRect = secondaryMediaContainer.getBoundingClientRect();
    const clickX = e.clientX - containerRect.left;
    const containerWidth = containerRect.width;
    
    // Si el click es en la mitad izquierda, ir al anterior
    if (clickX < containerWidth / 2) {
        const prevIndex = currentMediaIndex - 1;
        goToMedia(prevIndex);
    } 
    // Si el click es en la mitad derecha, ir al siguiente
    else {
        const nextIndex = currentMediaIndex + 1;
        goToMedia(nextIndex);
    }
});

  ['mousedown', 'touchstart'].forEach(event => videoPopup.addEventListener(event, startDrag));
  ['mousemove', 'touchmove'].forEach(event => document.addEventListener(event, drag));
  ['mouseup', 'touchend'].forEach(event => document.addEventListener(event, endDrag));
});

